import { Row, Col } from "react-bootstrap";

import classes from "../orderApplication.module.scss";

const AppOrdersActionSelect = ({ setShowCopyOA, handleCalculate }) => {
	return (
		<Row className={classes.actions}>
			<Col className={classes.actionRow} md={12}>
				<div className={classes.label}>Seleccione una opción</div>

				<div className={`${classes.optionButton} ${classes.copyElement}`} onClick={() => setShowCopyOA(true)}>
					<span>
						<div>Crear copia</div> de las ordenes seleccionadas{" "}
					</span>
				</div>
				<div className={`${classes.optionButton} ${classes.copyCalculate}`} onClick={() => handleCalculate()}>
					<span>
						<div>Calcular necesidad</div> de compra{" "}
					</span>
				</div>
			</Col>

			<hr className={classes.separator} />
		</Row>
	);
};

export default AppOrdersActionSelect;
